var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secret-btns"},[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
            el: 'body',
            offset: 0
        }),expression:"{\n            el: 'body',\n            offset: 0\n        }"}],staticClass:"top-btn",attrs:{"href":"#app"}},[_c('div',{staticClass:"in"},[_c('svgIcon',{staticClass:"icon-arrow-top",attrs:{"name":"arrow-top"}})],1),_c('small',[_vm._v("вверх")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }